/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import $ from "jquery";
import { latLng } from "leaflet";
// eslint-disable-next-line import/extensions
import "selectize/dist/js/standalone/selectize.min.js";
import "../utilities/selectize";

import Geocoder from "../utilities/geocoder";

class SelectLocationField extends Component {
  constructor(props) {
    super(props);
    const { SearchCache } = props;
    this.SearchCache = SearchCache;
  }

  componentDidMount() {
    const { placeholder, RegionService } = this.props;

    const $select = $(this.textInput).selectize({
      valueField: "formatted_address",
      labelField: "formatted_address",
      searchField: "formatted_address",
      placeholder,
      selectOnTab: true,
      create: false,
      score(search) {
        const score = this.getScoreFunction(search);
        return item => {
          if (item.index != null) {
            // if we have index, then we are in the geocoder search results; we want the
            // results to be displayed in order, but all scores have to be at above 0
            return 1000 - item.index;
          }
          return score(item);
        };
      },
      plugins: {
        empty_result: {
          message(query) {
            query = query.replace(/(<([^>]+)>)/gi, "");
            return `\
              <div class="selectize-dropdown-header">
                <div>We couldn't find "${query}"</div>
                <div><small>
                  Please check your spelling or try a different search,
                  for example ${RegionService.exampleText}
                </small></div>
              </div>\
              `;
          },
          empty() {
            return `\
              <div class="selectize-dropdown-header">
                <div>There are no recent results yet</div>
                <div><small>
                  Start typing to search,
                  for example ${RegionService.exampleText}
                </small></div>
              </div>\
              `;
          }
        }
      },

      render: {
        option(item, escape) {
          const address = escape(item.address);
          const suburb = escape(item.suburb || RegionService.defaultSuburb);
          return (
            "<div>" +
            `<div class="address">${address}</div>` +
            `<div class="suburb"><small>${suburb}</small></div>` +
            "</div>"
          );
        }
      },

      load(query, done) {
        this.clearOptions();

        if (this.SearchCache) {
          if (query.length === 0) {
            done(this.SearchCache.data);
            return;
          }

          if (query.length <= 2) {
            const results = this.SearchCache.search(query);
            done(results);
            return;
          }
        }

        // Geocode results
        const geoquery = new Geocoder(RegionService);
        geoquery
          .geocode(query)
          .then(result => {
            // Foreach result set an index
            result.map((item, index) => {
              result[index].index = index;
            });

            return done(result);
          })
          .catch(error => {
            console.warn(error);
            return done([]);
          });
      },

      onType() {
        return this.clearOptions();
      }
    });

    const selectize = $select[0].selectize;

    selectize.on("change", value => {
      const { onChange } = this.props;
      const item = selectize.options[value];
      const name = selectize.$input.attr("name");

      if (item) {
        const { lat, lng } = item;
        const latlong = latLng([lat, lng]);

        onChange({ [name]: value });

        // Add selected item to SearchCache
        this.SearchCache.add(item);

        if (/from/i.test(name)) {
          onChange({ fromLongitude: latlong.lng });
          onChange({ fromLatitude: latlong.lat });
        } else if (/to/i.test(name)) {
          onChange({ toLongitude: latlong.lng });
          onChange({ toLatitude: latlong.lat });
        }
      } else {
        // set an empty value if no results
        onChange({ [name]: "" });
      }
    });
  }

  render() {
    const { name } = this.props;

    return (
      <select
        ref={e => {
          this.textInput = e;
        }}
        name={name}
        className="select-field"
      />
    );
  }
}

export default SelectLocationField;
